import {Button} from 'antd';
import React, {useState, useEffect} from 'react';
import {MapContainer, Marker, Popup, WMSTileLayer} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import {Calendar, Modal, TimePicker} from 'antd';
import moment from 'moment';
import "./requestHomeTour.scss";
import {useNavigate, useParams} from 'react-router-dom';
import Notification from '../../reuseableComponents/Notification';
import {getPropertyByIdApi} from '../details/apis/apis';
import {createConversation} from "../conversation/apis/apis";
import {createHomeTourRequests} from "./apis/apis";


// Fix for missing marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const position = [1, 1];
const format = 'HH:mm';

const MapComponent = () => {
    const [state, setState] = useState({
        details: null,
        user: null,
        position: [],
        selectedDate: null,
        selectedTime: null
    })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {id} = useParams()

    const getPropertyFunction = async () => {
        try {
            let result = await getPropertyByIdApi(id)

            if (result?.status) {
                setState({
                    ...state,
                    details: result.data.data,
                    user: result.data.data?.user,
                    position: [result?.data?.data?.latitude, result?.data?.data?.longitude]
                })
            } else {
                Notification('error', "Error", "Error.");
            }
        } catch (err) {
            Notification('error', "Error", "Error.");
        }
    }

    useEffect(() => {
        getPropertyFunction()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onDateChange = (date) => {
        setState({...state, selectedDate: date});
    };

    const onTimeChange = (time) => {
        setState({...state, selectedTime: time});
    };

    const navigate = useNavigate()

    const handleRequest = async () => {
        if (!state.selectedDate || !state.selectedTime) {
            Notification('error', 'Please select both date and time')
            return;
        }

        const formattedDate = state.selectedDate.format("YYYY-MM-DD");
        const formattedTime = state.selectedTime.format("HH:mm");

        console.log("Selected Date:", formattedDate);
        console.log("Selected Time:", formattedTime);

        await createHomeTourRequests({
            propertyId: id,
            tourDate: formattedDate,
            tourTime: formattedTime,
        })
        Notification("success", "Request Sent Successfully");
        setIsModalOpen(false);
    };

    let isLoggedIn = localStorage.getItem("token") && localStorage.getItem("userLogin");

    return (
        <div className={"requestHomeTour"}>
            {state.position.length > 0 &&
                <MapContainer center={state.position ? state.position : position} zoom={13} scrollWheelZoom={true}
                              style={{height: "60vh", width: "100%"}}>
                    <WMSTileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={state.position ? state.position : position}>
                        <Popup>Optional</Popup>
                    </Marker>
                </MapContainer>
            }
            <br/>
            <div style={{marginTop: 10}}>
                <h3>Location</h3>
                <p style={{marginTop: 6}}>{state.details?.address}</p>
            </div>
            <div style={{display: "flex", justifyContent: "end", gap: 10, marginTop: 30}}>
                <Button onClick={() => setIsModalOpen(true)} type={"primary"}>Request home tour</Button>
                <Button disabled={!isLoggedIn} type={"primary"} onClick={async ()=>{
                    await createConversation(state.user.id)
                    navigate("/conversation")
                }}>Contact</Button>
            </div>

            <Modal
                title="Request home tour"
                onCancel={() => setIsModalOpen(false)}
                open={isModalOpen}
                footer={false}
            >
                <p>Select a date and time to see the property</p>
                <div>
                    <Calendar fullscreen={false} onSelect={onDateChange}/>
                </div>
                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 20,
                    }}
                >
                    <h5>Time</h5>
                    <TimePicker
                        value={state.selectedTime}
                        onChange={onTimeChange}
                        defaultValue={moment("12:08", format)}
                        format={format}
                    />
                </div>
                <p style={{marginTop: 10}}>An expert will contact you shortly.</p>
                <Button
                    type="primary"
                    style={{width: "100%", marginTop: 10}}
                    onClick={handleRequest}
                >
                    Request
                </Button>
            </Modal>
        </div>
    );
};

export default MapComponent;
